/* global axios */
import ApiClient from './ApiClient';

// `axios` aqui é a GLOBAL que o app configura com as credenciais da sessão
// (mesmo padrão de ApiClient.js e providerLogs.js). Importar o módulo em vez
// da global traz uma instância limpa, sem os headers de autenticação — a
// requisição sai sem credencial e o servidor devolve 401, que o componente
// exibe como "nenhum grupo encontrado".

// Endpoint custom da Task 10 (DEC-069): lista os grupos da instância UAZAPI e
// grava a allowlist via `save!(validate: false)`, para não bater no
// GET /instance/status do update genérico quando a instância está fora do ar.
class UazapiGroupsAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/uazapi_groups`);
  }

  update(inboxId, enabledGroups) {
    return axios.put(`${this.url}/${inboxId}/uazapi_groups`, {
      enabled_groups: enabledGroups,
    });
  }
}

export default new UazapiGroupsAPI();
